import {
  GetShiftsDocument,
  GetShiftsQueryVariables,
} from '@/graphql/generated-types';
import { ShiftFragment } from '@/graphql/types';
import { apolloClient } from '@/utils/apollo';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const getShifts = async (
  variables: GetShiftsQueryVariables
): Promise<ShiftFragment[]> => {
  const response = await apolloClient.query({
    query: GetShiftsDocument,
    variables,
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });

  if (response.data.schedule?.shifts) {
    return response.data.schedule.shifts as ShiftFragment[];
  }

  throw new SentryGraphQLError(`api.workSchedule.getShifts`, response);
};

export default {
  getShifts,
};
